import React, { useState, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/images/logo/online-logo.png";
import { useTranslation } from "react-i18next";
import i18n from "../i18n";

const MobileMenu = ({ activeMenu, setActiveMenu }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const isRTL = i18n.language === "ar";

  const isActive = (path) => location.pathname === path;

  const navLinks = useMemo(
    () => [
      { to: "/", label: t("nav.home") },
      { to: "/about", label: t("nav.about_us") },
      { to: "/service", label: t("nav.services") },
      { to: "/special-needs", label: t("nav.special_needs") },
      { to: "/blogs", label: t("nav.blogs") },
      { to: "/contacts", label: t("nav.contacts") },
    ],
    [t]
  );

  return (
    <>
      <div className="openmobile-menu fixed top-0 h-screen pt-6 pb-6 bg-white shadow-box2 w-[280px] overflow-y-auto flex flex-col z-[999] active-mobile-menu">
        {/* Logo and Close */}
        <div className="flex justify-between px-4 flex-none items-center">
          <Link to="/" className="brand-logo flex-none">
            <img src={logo} alt="logo" className="logo-mobile" />
          </Link>
          <span
            className="text-3xl text-black cursor-pointer rt-mobile-menu-close"
            onClick={() => setActiveMenu(false)}
          >
            <iconify-icon icon="fe:close"></iconify-icon>
          </span>
        </div>

        {/* Menu */}
        <div className="mobile-menu mt-4 flex-1">
          <ul className="menu-active-classes space-y-4 px-4">
            {navLinks.map(({ to, label }) => (
              <li key={to}>
                <Link
                  to={to}
                  className={`block px-4 py-2 rounded transition ${
                    isActive(to)
                      ? "bg-primary text-white font-semibold"
                      : "text-black hover:bg-gray-100"
                  }`}
                  onClick={() => setActiveMenu(false)}
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Social */}
        <div className="flex-none pb-4 px-4">
          <ul
            className={`flex justify-center pt-8 space-x-4 ${
              isRTL ? "space-x-reverse" : ""
            }`}
          >
            {[
              {
                href: "https://www.facebook.com/online.institute11",
                icon: "bxl:facebook",
              },
              {
                href: "https://www.tiktok.com/@online_institutekw?_t=8jShYhf9fV4&_r=1",
                icon: "ic:baseline-tiktok",
              },
              {
                href: "https://www.instagram.com/online_institute/",
                icon: "bxl:instagram",
              },
              {
                href: "https://t.snapchat.com/jHxZSl9c",
                icon: "bxl:snapchat",
              },
            ].map(({ href, icon }) => (
              <li key={icon}>
                <a
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex h-12 w-12 items-center justify-center rounded-full bg-opacity-[0.08] text-2xl bg-secondary hover:bg-primary hover:text-white"
                >
                  <iconify-icon icon={icon}></iconify-icon>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Overlay */}
      <div
        className={`rt-mobile-menu-overlay ${activeMenu ? "active" : ""}`}
        onClick={() => setActiveMenu(false)}
      ></div>
    </>
  );
};

export default MobileMenu;
